<template>
  <div v-if="isShown" :class="['dialog', 'dialog--new', 'dialog--shortage', 'dialog--input', ...(othersClass || [])]">
    <div class="dialog-contain">
      <div class="dialog-tit">
        <i v-if="onClose" class="dialog-close dialog-close--left" @click="onClose"></i>
        <p>{{ titleText ? titleText : "温馨提示" }}</p>
      </div>
      <div :class="['dialog-text', textCenter ? 'dialog-text--center' : '']">
        <slot></slot>
        <slot name="extraInfo"></slot>
      </div>
      <!-- <div class="btn-box">
        <button v-if="cancelText && onCancel" class="btn btn-gray" @click="onCancel">{{ cancelText }}</button>
        <button class="btn btn-green" @click="onConfirm">{{ confirmText }}</button>
      </div> -->
      <div class="new-btn-box">
        <div v-if="cancelText && onCancel" class="new-btn new-btn-gray" @click="onCancel">{{ cancelText }}</div>
        <div class="new-btn new-btn-green" @click="onConfirm">{{ confirmText }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "isShown",
    "confirmText",
    "cancelText",
    "titleText",
    "onCancel",
    "onClose",
    "onConfirm",
    "contentStyle",
    "textCenter",
    "imageContent",
    "othersClass"
  ]
}
</script>
